import { fetchNoToken, fetchWithToken } from "../helpers/fetch";
import { authActions } from "../store/authSlice";
import { personActions } from "../store/personSlice";
import { showSimpleMessage } from "./ui";
import { setLocalStorageValue } from "../helpers/localStoreManager";

export const requestLogin = (email, password) => {
  return async (dispatch) => {
    try {
      const data = {
        api_user: {
          email: email,
          password: password,
        },
      };
      const response = await fetchNoToken("api/login", data, "POST");
      const body = await response.json();
      const errors = !body.success;
      if (errors) {
        dispatch(showSimpleMessage("Error", body.errors[0].title));
        console.log("Error:", body);
      } else {
        console.log("Response:", body);

        dispatch(authActions.login(body.jwt));

        setLocalStorageValue("localStorageAuth.isAuthenticated", true);
        setLocalStorageValue("localStorageAuth.jwt_token", body.jwt);

        const responseUserInfo = await fetchWithToken("api/v1/user_basic_info");
        const bodyUnserInfo = await responseUserInfo.json();
        if (bodyUnserInfo.errors) {
        } else {
          const dataUserInfo = bodyUnserInfo.data;
          dispatch(personActions.setRole(dataUserInfo.role));
          dispatch(personActions.setName(dataUserInfo.name));
          dispatch(personActions.setLastName(dataUserInfo.last_name));
        }
      }
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const requestLogout = (email, password) => {
  return async (dispatch) => {
    try {
      dispatch(authActions.logout());

      setLocalStorageValue("localStorageAuth.isAuthenticated", false);
      setLocalStorageValue("localStorageAuth.jwt_token", null);
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};
